import React from 'react';
import {makeStyles} from '@material-ui/styles';
import { BottomNavigation, BottomNavigationAction } from '@material-ui/core';
import Facebook from '@material-ui/icons/Facebook';
import Twitter from '@material-ui/icons/Twitter';
import LinkedIn from '@material-ui/icons/LinkedIn';

const useStyles = makeStyles({
    root: {
        "& .MuiBottomNavigationAction-root": {
            minWidth: 0,
            maxWidth: 250
        },
        "& .MuiSvgIcon-root": {
            fill: "tan",
            "&:hover": {
                fill: "tomato",
                fontSize: "1.8rem"
            }
        }
    }
})

const Footer = () => {
    const classes = useStyles()
    return (
        <BottomNavigation width="auto" style={{background: "#222"}}>
            <BottomNavigationAction
                className={classes.root}
                style={{padding:0}}
                icon={<Facebook/>}
                href="https://facebook.com/darko.emmanuel.127"
                target="_blank"
            />
            <BottomNavigationAction
                className={classes.root}
                style={{padding:0}}
                icon={<Twitter/>}
                href="https://twitter.com/DarkoEmmanuel4"
                target="_blank"
            />
            <BottomNavigationAction
                className={classes.root}
                style={{padding:0}}
                icon={<LinkedIn/>}
                href="https://www.linkedin.com/in/darko-emmanuel-541506119/"
                target="_blank"
            />
        </BottomNavigation>
    )
}

export default Footer
